var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"card-box"},[_c('form-modal',{attrs:{"show":_vm.showModal},on:{"update:show":function($event){_vm.showModal=$event},"on-submit":_vm.save}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }